/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mantine/core';
import {
  ECOM_IMAGE_POSITION_LIST,
  ECOM_PRINT_DESIGN_ITEM_TYPE_ENUM
} from '../../../../../config/constants';
import WsVariantPickerDesignInput from './WsVariantPickerDesignInput';
import { getSelectedEcomStoreProductDesigns } from '../../../../../helpers/webstoreHelper';

const WsVariantPickerDesignInputControls = ({
  ecomStoreProduct,
  onDesignAnswerChange,
  selectedVariant,
  selectedProductVariantsState,
  submitting,
  mediaQueries,
  baseStoreUrl,
  onNavigate
}) => {
  const { isTabletOrSmaller } = mediaQueries;
  const ecomOrderProductPrintImages =
    selectedProductVariantsState?.ecomOrderProductPrintImages || [];

  const { selectedDesigns } = getSelectedEcomStoreProductDesigns(
    ecomStoreProduct,
    selectedVariant?.ecomVendorProductVariant.pkEcomVendorProductVariant
  );

  const designImageInputs = selectedDesigns.flatMap((d) =>
    d.ecomVendorProductPrintDesignItems
      .filter(
        (i) =>
          i.type === 'personalized_text' ||
          i.fkEcomPrintDesignItemType ===
            ECOM_PRINT_DESIGN_ITEM_TYPE_ENUM.PERSONALIZED_TEXT
      )
      .map((i) => ({
        pkEcomVendorProductPrintDesignItem:
          i.pkEcomVendorProductPrintDesignItem,
        fkEcomVendorProductPrintDesign: d.pkEcomVendorProductPrintDesign,
        text: i.text,
        type: i.type,
        positionLabel:
          ECOM_IMAGE_POSITION_LIST.find(
            (p) => p.value === d.fkEcomImagePosition.toString()
          )?.label || '',
        fkEcomImagePosition: d.fkEcomImagePosition,
        itemProperties: i.itemProperties
      }))
      .sort(
        (a, b) =>
          a.fkEcomImagePosition - b.fkEcomImagePosition ||
          a.positionLabel.localeCompare(b.positionLabel)
      )
  );

  return designImageInputs.map((input) => {
    const printDesignState = ecomOrderProductPrintImages.find(
      (a) => a.fkEcomImagePosition === input.fkEcomImagePosition
    );

    const inputAnswer = printDesignState?.ecomOrderProductPrintImageAnswers?.find(
      (a) =>
        a.fkEcomVendorProductPrintDesignItem ===
        input.pkEcomVendorProductPrintDesignItem
    );

    return (
      <Grid.Col
        key={input.pkEcomVendorProductPrintDesignItem}
        span={isTabletOrSmaller ? 12 : 6}
        style={{ alignSelf: 'end' }}
      >
        <WsVariantPickerDesignInput
          baseStoreUrl={baseStoreUrl}
          disabled={submitting}
          input={input}
          inputAnswer={inputAnswer}
          onChange={(value, type, previewImage) => {
            onDesignAnswerChange(ecomStoreProduct.pkEcomStoreProduct, [
              ...ecomOrderProductPrintImages.filter(
                (a) => a.fkEcomImagePosition !== input.fkEcomImagePosition
              ),
              {
                fkEcomImagePosition: input.fkEcomImagePosition,
                src: '',
                ecomOrderProductPrintImageAnswers: [
                  ...(
                    printDesignState?.ecomOrderProductPrintImageAnswers || []
                  ).filter(
                    (a) =>
                      a.fkEcomVendorProductPrintDesignItem !==
                      input.pkEcomVendorProductPrintDesignItem
                  ),
                  {
                    fkEcomVendorProductPrintDesignItem:
                      input.pkEcomVendorProductPrintDesignItem,
                    previewImage,
                    file: type === 'file' ? value : null,
                    value: type === 'file' ? null : value
                  }
                ]
              }
            ]);
          }}
          onNavigate={onNavigate}
        />
      </Grid.Col>
    );
  });
};

WsVariantPickerDesignInputControls.propTypes = {
  baseStoreUrl: PropTypes.string,
  config: PropTypes.object,
  ecomStoreProduct: PropTypes.object,
  isBundleProduct: PropTypes.bool,
  isCartEdit: PropTypes.bool,
  mediaQueries: PropTypes.object,
  onDesignAnswerChange: PropTypes.func,
  onInputChange: PropTypes.func,
  onNavigate: PropTypes.func,
  onVariantChange: PropTypes.func,
  selectedOptions: PropTypes.array,
  selectedProductVariantsState: PropTypes.object,
  selectedVariant: PropTypes.object,
  submitting: PropTypes.bool,
  variantOptions: PropTypes.array
};

export default WsVariantPickerDesignInputControls;
